import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SvgComponent from '../../SvgComponent';
import { STATIC_ROOT } from '../../../constants';
import ButtonComponent from '../../button/ButtonComponent';
import { showModal } from '../../../services/modal/actions';
import { MODAL_TYPE_LOGIN, MODAL_TYPE_REGISTER } from '../../../services/modal/constants';

class LoggedOutComponent extends React.Component {
    showLoginModal = () => this.props.showModal(MODAL_TYPE_LOGIN);

    showRegisterModal = () => this.props.showModal(MODAL_TYPE_REGISTER);

    render() {
        const { i18n } = this.props;
        return (
            <div className="flex-container-h flex-center-alt">
                <ButtonComponent
                    cssClass="connexion hidden-mobonly"
                    color="second"
                    onClick={this.showLoginModal}
                    text={
                        <React.Fragment>
                            <SvgComponent src={`${STATIC_ROOT}/connexion.svg`} />
                            <span>{i18n.LOG_IN}</span>
                        </React.Fragment>
                    }
                />
                <ButtonComponent
                    cssClass="inscription hidden-mobonly"
                    color="third"
                    onClick={this.showRegisterModal}
                    text={i18n.REGISTER}
                />
            </div>
        );
    }
}

LoggedOutComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return { i18n: state.i18n.feature.header.MEMBER_NAV };
};

const mapDispatchToProps = { showModal };

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOutComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/LoggedOutComponent.js